import { render } from "./OphthalmologicalExaminationSection.vue?vue&type=template&id=d0c87052&scoped=true"
import script from "./OphthalmologicalExaminationSection.vue?vue&type=script&lang=js"
export * from "./OphthalmologicalExaminationSection.vue?vue&type=script&lang=js"

import "./OphthalmologicalExaminationSection.vue?vue&type=style&index=0&id=d0c87052&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c87052"]])

export default __exports__